import { Doughnut, mixins } from 'vue-chartjs'
import Chart from "chart.js";

const { reactiveProp } = mixins

export const DoughnutChart = {
  extends: Doughnut,
  mixins: [reactiveProp],
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)

    // if (this.chartData != null) {
    //   var ds = this.chartData.datasets[0];
    //   var cd = ds.data

    //   var total = 0
    //   cd.forEach((value) => {
    //     total += value;
    // });
    //   console.log(`The total: ${total}`)
    //   this.textCenter(total);
    // }
  },
  methods: {
    textCenter(value) {
      Chart.pluginService.register({
        beforeDraw: function(chart) {
          var width = chart.chart.width;
          var height = chart.chart.height;
          
          var ctx = chart.chart.ctx;

          if (ctx.canvas.id==="doughnut-chart") {
            console.log(chart.chart)
            ctx.restore();
            var fontSize = (height / 114).toFixed(2);
            ctx.font = fontSize + "em sans-serif";
            ctx.textBaseline = "middle";
  
            var text = value + "";
            var textX = Math.round((width - ctx.measureText(text).width) / 2);
            var textY = Math.floor(height / 1.82);
  
            ctx.fillText(text, textX, textY);
            ctx.save();
          }
        }
      });
    }
  }
}
